<script setup lang="ts">
  import { computed, useId, useSlots } from 'vue';
  import type { RecordProps } from './Record.types';
  import {
    recordContentClass,
    recordValueClass,
    recordExtraContentClass,
    recordLabelClass,
    recordContainerClass,
    recordWithoutBottomBorderClass,
  } from './Record.css';

  const props = withDefaults(defineProps<RecordProps>(), {
    hideBottomBorder: false,
  });

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-record-${uid}`);

  const slots = useSlots();
  const hasExtraContent = computed(() => !!slots.extra);

  const containerClasses = computed(() => [
    recordContainerClass,
    props.hideBottomBorder ? recordWithoutBottomBorderClass : null,
  ]);
</script>

<template>
  <div :class="containerClasses" :data-testid="resolvedTestId">
    <span :class="recordLabelClass">{{ label }}</span>
    <div :class="recordContentClass">
      <div :class="recordValueClass" :data-testid="`${resolvedTestId}-data`">
        <slot>{{ value || '-' }}</slot>
      </div>
      <div :class="recordExtraContentClass" v-if="hasExtraContent">
        <slot name="extra" />
      </div>
    </div>
  </div>
</template>
